const initializeCosmoStories = (root = document) => {
  root.querySelectorAll('[data-cosmo-story]').forEach((section) => {
    if (section.dataset.ready === 'true') return;
    section.dataset.ready = 'true';
    if (section.dataset.motion !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add('is-visible');
      return;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      section.classList.add('is-visible');
      observer.disconnect();
    }, { threshold: 0.12 });
    observer.observe(section);
  });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeCosmoStories(), { once: true });
else initializeCosmoStories();
document.addEventListener('shopify:section:load', (event) => initializeCosmoStories(event.target));
